import { Inject, Injectable } from '@angular/core';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { fromEvent } from 'rxjs';

import { SIGNAL_R_API_URL_TOKEN } from '../tokens';

export interface HubConnectionParams {
  token: string;
  accountId: string;
}

@Injectable()
export class SignalRService {
  public hubConnection: HubConnection;

  constructor(@Inject(SIGNAL_R_API_URL_TOKEN) private signalrApiUrl: string) {}

  public async connect({ token, accountId }: HubConnectionParams) {
    const url = `${this.signalrApiUrl}/hub?accountId=${accountId}`;
    this.hubConnection = new HubConnectionBuilder()
      .configureLogging(LogLevel.None)
      .withUrl(url, {
        accessTokenFactory: () => token,
      })
      .build();
    await this.hubConnection.start();
  }

  public async invoke(method: string, ...params: unknown[]) {
    await this.hubConnection.invoke(method, ...params);
  }

  public async send(method: string, ...params: unknown[]) {
    await this.hubConnection.send(method, params);
  }
  public async stop() {
    await this.hubConnection.stop();
  }

  public messages<T = unknown>(messageType: string) {
    return fromEvent<T>(this.hubConnection, messageType);
  }

  public clearMessage(messageType: string) {
    this.hubConnection.off(messageType);
  }
}
